document.addEventListener("DOMContentLoaded", () => {

    /////////////// ACCORDION ////////////////////

  const accordionHeaders = document.querySelectorAll('.kaspersky-accordion__header');

  accordionHeaders.forEach((accHeader) => {
    const accordionIcon = accHeader.querySelector('.kaspersky-accordion__icon');
    const accordionContent = accHeader.nextElementSibling;

    accHeader.addEventListener('click', () => {
      const isOpen = accordionContent.classList.toggle('active');

      // Toggle the clicked panel's icon
      accordionIcon.textContent = isOpen ? '−' : '+';

      // Toggle the active class for the header and icon
      accHeader.classList.toggle('active');
      accordionIcon.classList.toggle('active');
    });

    accHeader.addEventListener('mouseover', () => {
      accordionIcon.classList.add('hover');
    });

    accHeader.addEventListener('mouseout', () => {
      accordionIcon.classList.remove('hover');
    });
  });


   /////////////// CLOSE ACCORDION ////////////////////


  /////////////// STICKY STUFF ////////////////////

// Get the menu element and the section element
const menu = document.getElementById('kaspersky-sticky-header-menu');
const displayMenuSection = document.getElementById('display-kaspersky-sticky-header-menu');

// Function to check if an element is at the top of the viewport
function isAtTopOfViewport(element) {
  const rect = element.getBoundingClientRect();
  return rect.top <= -304;
}

// Function to check if an element is fully out of the viewport
function isOutOfViewport(element, offset = 0) {
  const rect = element.getBoundingClientRect();
  return rect.bottom + offset <= 0;
}

// Function to handle scroll event
function handleScroll() {
  if (isAtTopOfViewport(displayMenuSection) && !isOutOfViewport(displayMenuSection, -304)) {
    menu.classList.remove('hidden');
  } else {
    menu.classList.add('hidden');
  }
}

// Listen for scroll event
window.addEventListener('scroll', handleScroll);





  //////////////// CLOSE STICKY STUFF ////////////



  //////////////// OTHERE JAVA STUFF

  // Generic function to show/hide price blocks
  const showPriceBlock = (selector, selectedIndex) => {
    const priceBlocks = document.querySelectorAll(selector);
    priceBlocks.forEach((block, index) => {
      if (index === selectedIndex) {
        block.classList.remove('hidden');
      } else {
        block.classList.add('hidden');
      }
    });
  };

  // Function to initialize price blocks for a column
  const initializePriceBlocks = (dropdownId, blockSelector) => {
    // Initially show the first price block
    showPriceBlock(blockSelector, 0);

    // Event listener for dropdown change
    document.getElementById(dropdownId).addEventListener('change', (event) => {
      const selectedIndex = event.target.selectedIndex;
      showPriceBlock(blockSelector, selectedIndex);
    });
  };

  // Initialize left column
  initializePriceBlocks('kaspersky-pricing-lft-col-drop-field', '.left-column-price-block');

  // Initialize center column
  initializePriceBlocks('kaspersky-pricing-cntr-col-drop-field', '.centre-column-price-block');

  // Initialize right column
  initializePriceBlocks('kaspersky-pricing-rgt-col-drop-field', '.rgt-column-price-block');

});
